<template>
    <flash-message></flash-message>
    <div v-if="auth.status.loggedIn" class="page">
        <navigation :menu="menu" :user-menu="userMenu" v-if="auth.status.loggedIn"></navigation>
        <router-view />
    </div>
    <router-view v-else />
</template>

<script>
import Navigation from "./components/Navigation.vue";
import FlashMessage from "./components/FlashMessage.vue";
import { mapState } from "vuex";
import Intercom from "@intercom/messenger-js-sdk";

export default {
    components: { FlashMessage, Navigation },
    computed: {
        ...mapState(["auth", "theme", "credit"]),

        menu() {
            const list = [
                { title: "AI Generated Videos", icon: "face-id", route: "home" },
                { title: "Create Video", icon: "plus", route: "create" },

                { title: "Uploads", icon: "folder", route: "upload" },
                { title: "Buy Credits", icon: "coin", route: "credits" },

                { title: "Profile", icon: "profile", route: "profile" }
            ];

            return list;
        }
    },
    methods: {
        loadProfile() {
            this.$store.dispatch("auth/info").then((data) => {
                Intercom({
                    app_id: "qwsa3ken",
                    email: data.email,
                    name: data.name,
                    user_id: data.id,
                    created_at: data.created
                });

                this.$store.dispatch("credit/update").then(() => {
                    // update credits
                    // console.log(this.credit);
                }).catch(e => {
                    this.flashError(e.message ? e.message : "Error occurred");
                });
            }).catch(e => {
                if (e.message) {
                    this.flashError(e.message);
                } else {
                    console.error(e);
                }
            });
        }
    },
    mounted() {
        if (this.auth && this.auth.status && this.auth.status.loggedIn) {
            this.loadProfile();
        }

        this.$store.subscribeAction((action, state) => {
            if (action.type === "auth/tokenError") {
                this.flashError("Session is invalid");
                const query = this.$route.name !== "login" ? { next: this.$route.fullPath } : null;
                this.$router.push({ name: "login", query });
            }
        });
    },
    data() {
        return {
            userMenu: [
                /* { title: "Settings", icon: "users", route: "home" }, */
                { title: "Logout", icon: "logout", route: "logout" }
            ]
        };
    }
};
</script>
<style type="scss">
[v-cloak] { display: none; }
</style>
